import { UntypedFormControl, ValidationErrors } from "@angular/forms";
import { ConfigOption, FormlyFieldConfig } from "@ngx-formly/core";
import { contractFactorTermValidator, mailsValidator, mailValidator, phoneAfterPipeValidator, urlValidator } from "../../@core/utils/helper";
import { CustomFieldsFormWidgetComponent } from "../../shared/components/custom-fields-form-widget/custom-fields-form-widget.component";
import { EntityPropertyChooserComponent } from "../../shared/components/entity-property-chooser/entity-property-chooser.component";
import { EntityPropertyDropdownComponent } from "../../shared/components/entity-property-dropdown/entity-property-dropdown.component";
import { LocalizedStringInputComponent } from "../../shared/components/localized-string-input/localized-string-input.component";
import { PhxCheckboxComponent } from "../../shared/components/phx-input-checkbox/phx-input-checkbox.component";
import { PhxMessageComponent } from "../../shared/components/phx-message/phx-message.component";
import { PhxSliderComponent } from "../../shared/components/phx-slider/phx-slider.component";
import { SortChooserComponent } from "../../shared/components/sort-chooser/sort-chooser.component";
import { FormlySetRoleToUserComponent } from "../../shared/modules/role/widget-set-role-to-user/formly-set-role-to-user.component";
import { FormlySetUserToRoleComponent } from "../../shared/modules/role/widget-set-user-to-role/formly-set-user-to-role.component";
import { SHARED_FORMLY_TYPES } from "../../shared/shared.formly-types";
import { ADMIN_FORMLY_TYPES } from "../admin/admin.formly-types";
import { FormlySetMenuToRoleComponent } from "../admin/components/widget-set-menu-to-role/formly-set-menu-to-role.component";
import { FormlySetMenuToUserComponent } from "../admin/components/widget-set-menu-to-user/formly-set-menu-to-user.component";
import { FormlySetRoleToMenuComponent } from "../admin/components/widget-set-role-to-menu/formly-set-role-to-menu.component";
import { FormlySetUserToMenuComponent } from "../admin/components/widget-set-user-to-menu/formly-set-user-to-menu.component";
import { ASSET_FORMLY_TYPES } from "../asset/asset.formly-types";
import { BANKING_FORMLY_TYPES } from "../banking/banking.formly-types";
import {
  FormlyContactsLookupComponent
} from "../crm/components/formly-contacts-lookup/formly-contacts-lookup.component";
import { CRM_FORMLY_TYPES } from "../crm/crm.formly-fields";
import { TRANSPORT_ROUTE_FORMLY_TYPES } from "../masterdata/transport-route/transport-route.formly-types";
import { PURCHASE_FORMLY_TYPES } from "../purchase/purchase.formly-types";
import { CONTACT_FORMLY_TYPES } from "../crm/modules/contact/contact.formly-types";
import { POSTAL_ADDRESS_FORMLY_TYPES, POSTAL_ADDRESS_FORMLY_WRAPPERS } from "../crm/modules/postal-address/postal-address.formly-types";
import { CUSTOM_ENTITY_FORMLY_TYPES } from "../custom-entity/custom-entity.formly-types";
import { DOCUMENTS_POSTAL_ADDRESSES_FORMLY_TYPES } from "../documents/components/document-postal-addresses/document-postal-addresses.formly-types";
import { DOCUMENTS_FORMLY_TYPES } from "../documents/documents.formly-types";
import { FIBU_FORMLY_TYPES } from "../fibu/fibu.formly-types";
import { FINANCE_FORMLY_TYPES } from "../finance/finance.formly-types";
import { HRM_FORMLY_TYPES } from "../hrm/hrm.formly-fields";
import { JOURNAL_FORMLY_TYPES } from "../journal/journal.formly-types";
import { MACRO_FORMLY_TYPES } from "../macro/macro.formly-types";
import { CONSTANTS_FORMLY_TYPES } from "../masterdata/constants/constants.formly-types";
import { COST_TYPES_FORMLY_TYPES } from "../masterdata/cost-types/cost-types.formly-types";
import { DELIVERY_TERMS_FORMLY_TYPES } from "../masterdata/delivery-terms/delivery-terms.formly-types";
import { HARBOUR_FORMLY_TYPES } from "../masterdata/harbour/harbour.formly-types";
import { PAYMENT_TERMS_FORMLY_TYPES } from "../masterdata/payment-terms/payment-terms.formly-types";
import { SHIPPING_METHOD_FORMLY_TYPES } from "../masterdata/shipping-method/shipping-method.formly-types";
import { TAX_FORMLY_TYPES } from "../masterdata/tax/tax.formly-types";
import { SIMPLE_JSON_ENTRY_FORMLY_VALIDATION_MESSAGES, SIMPLE_JSON_ENTRY_FORMLY_VALIDATORS } from "../misc/simple-json-entry/simple-json-entry.module";
import { MOBILE_FORMLY_TYPES } from "../mobile/mobile.formly-types";
import { MOBILE_DOCUMENTS_FORMLY_TYPES } from "../mobile/submodules/mobile-documents/mobile-documents.formly-types";
import { ReportDropDownComponent } from "../printing/controls/report-drop-down/report-drop-down.component";
import { PRODUCTION_FORMLY_TYPES } from "../production/production.formly-types";
import { ProductDropDownComponent } from "../products/modules/product-chooser/product-dropdown.component";
import { PRODUCTS_FORMLY_TYPES } from "../products/products.formly-types";
import { PROMOTION_FORMLY_TYPES } from "../promotion/promotion.formly-types";
import { FormlyEntityTranslationsWidgetComponent } from "../../shared/components/formly-entity-translations-widget/formly-entity-translations-widget.component";
import { LanguageEnumDropdownComponent } from "../shared/components/language-enum-dropdown/language-enum-dropdown.component";
import { TASK_FORMLY_TYPES } from "../task/task.formly-types";
import { TIMELINE_FORMLY_TYPES } from "../timeline/timeline.formly-types";
import { WAREHOUSE_FORMLY_TYPES } from "../warehouse/warehouse.formly-types";
import { AccordionWrapperComponent } from "./accordion-wrapper/accordion-wrapper.component";
import { FormlyFieldButton } from "./button-type/button-type.component";
import { FormlyContractTermPresetsComponent } from "./formly-contract-term-presets/formly-contract-term-presets.component";
import { DecimalPlacesSelectComponent } from './decimal-places-select/decimal-places-select.component';
import { DLILineSumInputComponent } from "./dli-line-sum-input/dli-line-sum-input.component";
import { FormlyAssetWidgetComponent } from "./formly-asset-widget/formly-asset-widget.component";
import { FormlyColorPickerComponent } from "./formly-color-picker/formly-color-picker.component";
import { FormlyDatePickerComponent } from "./formly-date-picker/formly-date-picker.component";
import { FormlyEmployeeEditComponent } from "./formly-employee-edit/formly-employee-edit.component";
import { FormlyEntityFieldConfigWidgetComponent } from "./formly-entity-field-config-widget/formly-entity-field-config-widget.component";
import { FormlyFieldEmailConnectionTypeComponent } from "./formly-field-email-connection-type/formly-field-email-connection-type.component";
import { FormlyFieldIntegrationCategoryComponent } from "./formly-field-integration-category/formly-field-integration-category.component";
import {
  FormlyFieldIntegrationTypeComponent
} from "./formly-field-integration-type/formly-field-integration-type.component";
import { FormlyFieldProductPriceListDropDownComponent } from "./formly-field-product-price-list-drop-down/formly-field-product-price-list-drop-down.component";
import { FormlyFieldStatusBadgeComponent } from "./formly-field-status-badge/formly-field-status-badge.component";
import { FormlyGenericButtonCardComponent } from "./formly-generic-button-card/formly-generic-button-card.component";
import { FormlyInputAutoCompleteComponent } from "./formly-input-chip/formly-input-chip.component";
import { FormlyJsonataEditorComponent } from './formly-jsonata-editor/formly-jsonata-editor.component';
import { FormlyJsoNataSchemasDropDownComponent } from './formly-jso-nata-schemas-drop-down/formly-jso-nata-schemas-drop-down.component';
import { FormlyMailInput } from "./formly-mail-input/formly-mail-input.component";
import { FormlyPersistButtonComponent } from "./formly-persist-button/formly-persist-button.component";
import {
  FormlyPhxInputQuantityWithWarehouseComponent
} from "./formly-phx-input-quantity-with-warehouse/formly-phx-input-quantity-with-warehouse.component";
import { FormlyPhxInputComponent } from "./formly-phx-input/formly-phx-input.component";
import { FormlyPhxSelectComponent } from './formly-phx-select/formly-phx-select.component';
import { FormlyPhxTextareaComponent } from "./formly-phx-textarea/formly-phx-textarea.component";
import { FormlyPostalcodeAutoCompleteComponent } from './formly-postalcode-auto-complete/formly-postalcode-auto-complete.component';
import { FormlyPriceInputComponent } from "./formly-price-input/formly-price-input.component";
import { FormlyProductGroupIntegrationLinkListComponent } from './formly-product-group-integration-link-list/formly-product-group-integration-link-list.component';
import { FormlyProductIntegrationLinkListComponent } from './formly-product-integration-link-list/formly-product-shop-integration-link-list.component';
import { FormlySerialListComponent } from './formly-serial-list/formly-serial-list.component';
import {
  FormlyStorageQuantityInputComponent
} from "./formly-storage-quantity-input/formly-storage-quantity-input.component";
import { FormlyTabsComponent } from "./formly-tabs/formly-tabs.component";
import { LayoutEditNodeWrapperComponent } from "./layout-edit-node-wrapper/layout-edit-node-wrapper.component";
import { FormlyWebsiteInput } from "./formly-website-input/formly-website-input.component";
import { FormlyIconCssInputComponent } from "./formly-icon-css-input/formly-icon-css-input.component";
import { FormlyVatIdInput } from "./formly-vat-id-input/formly-vat-id-input.component";
import { InputWithNumberGenComponent } from "./input-with-number-gen/input-with-number-gen.component";
import { NoHeaderPanelWrapperComponent } from "./no-header-panel-wrapper/no-header-panel-wrapper.component";
import { PanelWrapperComponent } from "./panel-wrapper/panel-wrapper.component";
import { PhoneInputComponent } from "./phone-input/phone-input.component";
import { PlusMinusButtonWidgetComponent } from "./plus-minus-button-widget/plus-minus-button-widget.component";
import { QuantityNumberInputComponent } from "./quantity-number-input/quantity-number-input.component";
import { RepeatSectionComponent } from "./repeat-section/repeat-section.component";
import { SimpleTitleWrapperProductComponent } from "./simple-title-wrapper/simple-title-wrapper-product";
import { SimpleTitleWrapperComponent } from "./simple-title-wrapper/simple-title-wrapper.component";

export function ModelHasIdValidator(control: UntypedFormControl): ValidationErrors {
  // return !control.value || /(\d{1,3}\.){3}\d{1,3}/.test(control.value) ? null : { 'ip': true };

  if (control.value)
    return null;

  return { 'modelSelected': false };
}

export function ModelHasIdMessage(err, field: FormlyFieldConfig) {
  // return `"${field.formControl.value}" ist nicht `;
  return "keine valide Auswahl";
}

export const customFormlyConfig: ConfigOption[] = [
  {
    types: [
      ...DOCUMENTS_FORMLY_TYPES,
      ...BANKING_FORMLY_TYPES,
      ...PAYMENT_TERMS_FORMLY_TYPES,
      ...CRM_FORMLY_TYPES,
      ...TRANSPORT_ROUTE_FORMLY_TYPES,
      ...PURCHASE_FORMLY_TYPES,
      ...TAX_FORMLY_TYPES,
      ...COST_TYPES_FORMLY_TYPES,
      ...PRODUCTS_FORMLY_TYPES,
      ...FIBU_FORMLY_TYPES,
      ...DOCUMENTS_POSTAL_ADDRESSES_FORMLY_TYPES,
      ...ADMIN_FORMLY_TYPES,
      ...ASSET_FORMLY_TYPES,
      ...CONTACT_FORMLY_TYPES,
      ...POSTAL_ADDRESS_FORMLY_TYPES,
      ...CUSTOM_ENTITY_FORMLY_TYPES,
      ...FINANCE_FORMLY_TYPES,
      ...JOURNAL_FORMLY_TYPES,
      ...TASK_FORMLY_TYPES,
      ...MACRO_FORMLY_TYPES,
      ...CONSTANTS_FORMLY_TYPES,
      ...DELIVERY_TERMS_FORMLY_TYPES,
      ...HARBOUR_FORMLY_TYPES,
      ...SHIPPING_METHOD_FORMLY_TYPES,
      ...MOBILE_DOCUMENTS_FORMLY_TYPES,
      ...MOBILE_FORMLY_TYPES,
      ...PRODUCTION_FORMLY_TYPES,
      ...PROMOTION_FORMLY_TYPES,
      ...TIMELINE_FORMLY_TYPES,
      ...SHARED_FORMLY_TYPES,
      ...WAREHOUSE_FORMLY_TYPES,
      ...HRM_FORMLY_TYPES,
      {
        name: 'formly-localized-string-input',
        component: LocalizedStringInputComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-language-enum-dropdown',
        component: LanguageEnumDropdownComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-product-drop-down',
        component: ProductDropDownComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'report-dropdown',
        component: ReportDropDownComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-entity-field-config',
        component: FormlyEntityFieldConfigWidgetComponent,
        wrappers: ['simple-title'],
      },
      //#region set-x-to-y
      {
        name: 'formly-set-role-to-user',
        component: FormlySetRoleToUserComponent,
      },
      {
        name: 'formly-set-user-to-menu',
        component: FormlySetUserToMenuComponent,
      },
      {
        name: 'formly-set-menu-to-role',
        component: FormlySetMenuToRoleComponent,
      },
      {
        name: 'formly-set-role-to-menu',
        component: FormlySetRoleToMenuComponent,
      },
      {
        name: 'formly-set-menu-to-user',
        component: FormlySetMenuToUserComponent,
      },
      {
        name: 'formly-set-user-to-role',
        component: FormlySetUserToRoleComponent,
      },
      //#endregion
      {
        name: 'formly-input-chip',
        component: FormlyInputAutoCompleteComponent,
      },
      {
        name: 'formly-color-picker',
        component: FormlyColorPickerComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-contacts-lookup',
        component: FormlyContactsLookupComponent
      },
      {
        name: 'formly-plus-minus-button',
        component: PlusMinusButtonWidgetComponent,
      },
      //deprecated!
      // {
      //   name: 'formly-phx-number-input',
      //   component: FormlyPhxNumberInputComponent,
      //   wrappers: ['simple-title']
      // },
      // for adding classes to input element in fallback fields
      {
        name: 'input',
        component: FormlyPhxInputComponent,
        wrappers: ['simple-title']
      },
      // {
      //   name: 'formly-phx-input',
      //   component: FormlyPhxInputComponent,
      //   wrappers: ['simple-title']
      // },
      {
        name: 'textarea',
        component: FormlyPhxTextareaComponent,
        wrappers: ['simple-title']
      },
      {
        name: 'formly-phx-select',
        component: FormlyPhxSelectComponent,
        wrappers: ['simple-title']
      },
      {
        name: 'formly-number-input',
        component: DLILineSumInputComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-price-input',
        component: FormlyPriceInputComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-storage-quantity-input',
        component: FormlyStorageQuantityInputComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-quantity-input',
        component: QuantityNumberInputComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'checkbox',
        component: PhxCheckboxComponent,
        wrappers: [], //checkboxes dont have a title wrapper
        //we could set the default size to large:
        // defaultOptions: {
        //   props: {
        //     size: 'large',
        //   }
        // }
      },
      {
        name: 'formly-mail-input',
        component: FormlyMailInput,
        wrappers: ['simple-title']
      },
      {
        name: 'formly-website-input',
        component: FormlyWebsiteInput,
        wrappers: ['simple-title']
      },
      {
        name: 'icon-css-input',
        component: FormlyIconCssInputComponent,
        wrappers: ['simple-title']
      },
      {
        name: 'formly-vat-id-input',
        component: FormlyVatIdInput,
        wrappers: ['simple-title']
      },
      {
        name: 'formly-phone-input',
        component: PhoneInputComponent,
        wrappers: ['simple-title'],
      },
      // { name: 'formly-sub-contacts', component: FormlySubContactsComponent },
      // { name: 'px-button', component: DxButton },
      // { name: 'px-textarea', component: DxTextArea },
      // { name: 'px-textbox', component: DxTextBox },
      { name: 'repeat', component: RepeatSectionComponent },
      { name: 'tabBootstrap', component: FormlyTabsComponent, defaultOptions: { wrappers: [] } },
      {
        name: 'formly-input-with-num-gen', component: InputWithNumberGenComponent,
        wrappers: ['simple-title'],
      }, {
        name: 'formly-date-picker', component: FormlyDatePickerComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-generic-button-card',
        component: FormlyGenericButtonCardComponent,
      },
      {
        name: 'formly-employee-edit-widget',
        component: FormlyEmployeeEditComponent
      },
      {
        name: 'formly-field-status-badge',
        component: FormlyFieldStatusBadgeComponent
      },
      {
        name: 'formly-field-integration-type',
        component: FormlyFieldIntegrationTypeComponent
      },
      {
        name: 'formly-field-product-price-list-drop-down',
        component: FormlyFieldProductPriceListDropDownComponent
      },
      {
        name: 'formly-field-integration-category',
        component: FormlyFieldIntegrationCategoryComponent
      },
      {
        name: 'formly-field-email-connection-type',
        component: FormlyFieldEmailConnectionTypeComponent
      },
      {
        name: "formly-product-integration-link-list",
        component: FormlyProductIntegrationLinkListComponent
      },
      {
        name: "formly-product-group-integration-link-list",
        component: FormlyProductGroupIntegrationLinkListComponent
      },
      {
        name: 'formly-json-nata-schemas-drop-down',
        wrappers: ['simple-title'],
        component: FormlyJsoNataSchemasDropDownComponent
      },
      {
        name: 'formly-jsonata-editor',
        component: FormlyJsonataEditorComponent,
      },
      {
        name: 'formly-button',
        component: FormlyFieldButton,
        defaultOptions: {
          props: {
            btnType: 'primary',
            type: 'primary',
          },
        },
      },
      {
        name: 'formly-contract-term-presets',
        component: FormlyContractTermPresetsComponent,
      },
      {
        name: 'input-quantity-with-warehouse',
        component: FormlyPhxInputQuantityWithWarehouseComponent,
      },
      {
        name: 'formly-zipcode-auto-complete',
        component: FormlyPostalcodeAutoCompleteComponent,
      },
      {
        name: 'formly-serial-list',
        component: FormlySerialListComponent,
      },
      {
        name: 'formly-entity-translations',
        component: FormlyEntityTranslationsWidgetComponent,
      },
      {
        name: 'formly-asset-widget',
        component: FormlyAssetWidgetComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-custom-fields-form-widget',
        component: CustomFieldsFormWidgetComponent,
      },
      {
        name: 'formly-decimal-places-select',
        component: DecimalPlacesSelectComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'phx-slider',
        component: PhxSliderComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-entity-property-dropdown',
        component: EntityPropertyDropdownComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-entity-property-chooser',
        component: EntityPropertyChooserComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-sort-chooser',
        component: SortChooserComponent,
        wrappers: ['simple-title'],
      },
      {
        name: 'formly-phx-message',
        component: PhxMessageComponent,
      },
    ],
    wrappers: [
      ...POSTAL_ADDRESS_FORMLY_WRAPPERS,
      { name: 'accordion', component: AccordionWrapperComponent },
      { name: 'panel', component: PanelWrapperComponent },
      { name: 'no-header-panel', component: NoHeaderPanelWrapperComponent },
      { name: 'simple-title', component: SimpleTitleWrapperComponent },
      { name: 'simple-title-product', component: SimpleTitleWrapperProductComponent },
      { name: 'persist-button', component: FormlyPersistButtonComponent },
      { name: 'layout-edit-node', component: LayoutEditNodeWrapperComponent },
    ],
    validators: [
      ...SIMPLE_JSON_ENTRY_FORMLY_VALIDATORS,
      { name: 'modelSelected', validation: ModelHasIdValidator },
      { name: 'url', validation: urlValidator },
      { name: 'mail', validation: mailValidator },
      { name: 'mails', validation: mailsValidator() },
      { name: 'phone', validation: phoneAfterPipeValidator },
      { name: 'contractFactorTerm', validation: contractFactorTermValidator }
    ],
    validationMessages: [
      ...SIMPLE_JSON_ENTRY_FORMLY_VALIDATION_MESSAGES,
      { name: 'modelSelected', message: ModelHasIdMessage },
    ],
    extras: {
      // lazyRender: true
      //causes problems in tab component (not visible tabs are not loaded correctly, dropdown issue maybe)
    }
  }
]